import React from 'react';
import '../css/Blog.css'

const BlogPage = ({ posts }) => {

    return (
        <div className='blog-page'>
            {posts.map((post, index) => (
                <div className="blog-post" key={index}>
                    <h3 className="blog-post-subtitle">{post.subtitle}</h3>
                    {post.img && <img src={post.img} alt={`Imagem ${index + 1}`} className="blog-post-img" />}
                    <p className="blog-post-text">{post.text}</p>
                </div>
            ))}
        </div>
    );
};

export default BlogPage;